module.exports = __webpack_public_path__ + "static/media/welcome-modal-content.2652eae4.jpg";